import { useEffect, useState } from "react";
import { api, apiError } from "../lib/api";
import { toast } from "sonner";
import { HardDrive } from "lucide-react";

export default function StorageStatsPage() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/admin/storage-stats");
                setRows(data);
            } catch (e) { toast.error(apiError(e)); }
            finally { setLoading(false); }
        })();
    }, []);
    const totalMB = rows.reduce((s, r) => s + (r.mb || 0), 0);
    const totalCount = rows.reduce((s, r) => s + (r.photo_count || 0), 0);
    return (
        <div className="mx-auto max-w-3xl px-4 sm:px-6 py-6 sm:py-10">
            <div>
                <div className="text-xs font-medium uppercase tracking-wider text-gray-500">HO Admin</div>
                <h1 className="font-display text-2xl sm:text-3xl font-bold text-[#1E3355] mt-1">Photo Storage</h1>
                <p className="text-sm text-gray-500 mt-1">Per-site photo count and disk usage. Total: <span className="font-semibold text-[#1E3355]">{totalCount} photos · {totalMB.toFixed(2)} MB</span></p>
            </div>
            <div className="mt-6 rounded-xl bg-white border border-gray-100 fx-shadow-card overflow-hidden">
                <table className="w-full text-sm" data-testid="storage-stats-table">
                    <thead className="bg-[#F4F6F9]">
                        <tr className="text-left text-[11px] font-semibold uppercase tracking-wider text-gray-500">
                            <th className="px-4 py-3">Site</th>
                            <th className="px-4 py-3 text-right">Photos</th>
                            <th className="px-4 py-3 text-right">Size (MB)</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {loading ? <tr><td colSpan="3" className="p-6 text-center text-sm text-gray-500">Loading…</td></tr> :
                        rows.map((r) => (
                            <tr key={r.site_id} data-testid={`storage-row-${r.site_name}`}>
                                <td className="px-4 py-3 font-medium text-[#1E3355] inline-flex items-center gap-2"><HardDrive className="w-3.5 h-3.5 text-gray-400" /> {r.site_name}</td>
                                <td className="px-4 py-3 text-right tabular-nums">{r.photo_count}</td>
                                <td className="px-4 py-3 text-right tabular-nums font-medium">{r.mb.toFixed(2)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
